import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, PLATFORM_ID, input } from '@angular/core';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';
import { Partner } from '@app/models/partner/IPartner';
import { HotelFiltersService } from '@app/services/hotelfilters.service';
import { Subject, takeUntil } from 'rxjs';
@Component({
    selector: 'clever-transfer',
    templateUrl: './transfer.component.html',
    styleUrls: ['./transfer.component.scss'],
    standalone: false
})
export class TransferHotelComponent implements OnInit, OnDestroy {
    protected unsubscribe$ = new Subject();
    readonly mode = input<string>(undefined);
    readonly partner = input<Partner>(undefined);
    readonly inclusiveListExt = input<any[]>(undefined);
    inclusiveList: any[];
    fromtraffics: boolean = false;
    isBrowser: boolean = false;
    mittransfer: boolean = false;
    ohnetransfer: boolean = false;
    mietwagen: boolean = false;
    zugtumflug: boolean = false;
    selectedList: string[] = [];

    constructor(
        @Inject(PLATFORM_ID) protected platformId: any,
        protected hotelService: HotelFiltersService,
        protected cdr: ChangeDetectorRef
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    ngOnInit(): void {
        if (this.isBrowser) {
            const inclusiveListExt = this.inclusiveListExt();
            if (inclusiveListExt?.length > 0) {
                this.fromtraffics = true;
                const tmp = [];
                for (let i = 0; i < inclusiveListExt.length; i++) {
                    if (
                        inclusiveListExt[i].code === 'MT' ||
                        inclusiveListExt[i].code === 'OT' ||
                        inclusiveListExt[i].code === 'MW' ||
                        inclusiveListExt[i].code === 'ZG') {
                        tmp.push(inclusiveListExt[i]);
                    }
                }
                this.inclusiveList = this.sortArray(tmp);
            }
            this.initFilterSub();
        }
    }

    sortArray(array): any[] {
        if (array?.length > 0) {
            array?.sort((a, b) => {
                a = a.name.toLowerCase();
                b = b.name.toLowerCase();

                return a < b ? -1 : a > b ? 1 : 0;
            });
        }
        return array;
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    checkList(): void {
        for (let i = 0; i < this.inclusiveList?.length; i++) {
            if(this.inclusiveList[i].code) {

            }
        }
    }

    selectmittransfer() {
        this.mittransfer = !this.mittransfer;
        this.hotelService.transferlist('MT', this.mittransfer, this.mode() !== 'home');
    }

    selectohnetransfer() {
        this.ohnetransfer = !this.ohnetransfer;
        this.hotelService.transferlist('OT', this.ohnetransfer, this.mode() !== 'home');
    }

    selectmietwagen() {
        this.mietwagen = !this.mietwagen;
        this.hotelService.transferlist('MW', this.mietwagen, this.mode() !== 'home');
    }

    selectzugtumflug() {
        this.zugtumflug = !this.zugtumflug;
        this.hotelService.transferlist('ZG', this.zugtumflug, this.mode() !== 'home');
    }

    selected(op): void {
        let push = true;
        if (this.selectedList.indexOf(op) >= 0) {
            push = false;
        }
        this.hotelService.transferlist(op, push, this.mode() !== 'home');
        this.cdr.detectChanges();
    }

    initFilterSub(): void {
        this.hotelService.getfilters$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((filter: ParamFilters) => {
            this.mittransfer = false;
            this.mietwagen = false;
            this.ohnetransfer = false;
            this.zugtumflug = false;
            this.selectedList = [];
            for (let i = 0; i < filter.transferlist?.length; i++) {
                if (filter.transferlist[i] === 'MT') {
                    this.mittransfer = true;
                    this.selectedList.push('MT');
                }
                if (filter.transferlist[i] === 'OT') {
                    this.ohnetransfer = true;
                    this.selectedList.push('OT');
                }
                if (filter.transferlist[i] === 'MW') {
                    this.mietwagen = true;
                    this.selectedList.push('MW');
                }
                if (filter.transferlist[i] === 'ZG') {
                    this.zugtumflug = true;
                    this.selectedList.push('ZG');
                }
            }
            this.cdr.detectChanges();
        });
    }
}

/*
{
            code: 'MT',
            name: 'mit Transfer',
            checked: false
        },
        {
            code: 'OT',
            name: 'ohne Transfer',
            checked: false
        },
        {
            code: 'MW',
            name: 'Mietwagen',
            checked: false
        },
        {
            code: 'ZG',
            name: 'Zug zum Flug',
            name1: '(innerhalb Deutschland)',
            checked: false
        }
*/
